import { useMemo, useState } from 'react';
import { Box, Button, Flex } from '@mantine/core';

import {
  DetailsViewProperties as Properties,
  DetailsViewPropertiesContent as PropertiesContent,
  DetailsViewPropertiesHeader as PropertiesHeader,
} from 'components/shared';
import { SignIcon } from 'icons';

import { useTranslation } from 'react-i18next';
import { GeneralSettingsModal } from './GeneralSettingsModal';
import { useFormEditContext } from '../../context';

export const GeneralSettings = () => {
  const { t } = useTranslation(['forms', 'common']);
  const { form } = useFormEditContext();
  const properties = useMemo(
    () => [
      {
        label: t('editView.settings.name'),
        value: form.name,
      },
      {
        label: t('editView.settings.signMethod'),
        value: (
          <Flex align="center" gap="xs">
            <SignIcon />
            {form.signType === 'SMS'
              ? t('common:signTypes.sms')
              : t('common:signTypes.simple')}
          </Flex>
        ),
      },
    ],
    [t, form],
  );
  const [opened, setOpened] = useState(false);

  return (
    <Properties>
      <PropertiesHeader title={t('editView.sidebar.generalSettings.title')}>
        <Button variant="default" onClick={() => setOpened(true)}>
          {t('common:edit')}
        </Button>
        <GeneralSettingsModal
          opened={opened}
          onClose={() => setOpened(false)}
        />
      </PropertiesHeader>
      <PropertiesContent>
        <Flex direction="column" gap="md">
          {properties.map(({ label, value }) => (
            <Flex key={label} align="center">
              <Box sx={{ flex: '0 0 35%' }}>{label}</Box>
              <Box sx={{ flex: '0 0 65%' }}>{value}</Box>
            </Flex>
          ))}
        </Flex>
      </PropertiesContent>
    </Properties>
  );
};
